import React from 'react';
import { FormControl, InputLabel, Select as MuiSelect, MenuItem, FormHelperText } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';

import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';

export default function XCSearch(props) {
  const { label, customStyle } = props;
  const [currentValue, setCurrentValue] = React.useState('');

  const clear = () => {
    console.log('clear');
    setCurrentValue('');
  };

  const handleChange = (e) => {
    console.log(`XCSearch: handleChange - value[${e.target.value}]`);
    setCurrentValue(e.target.value);
    const { filter } = props;
    filter(e.target.value);
  };

  const handleChangeComplete = (e) => {
    console.log(`XCSearch: handleChangeComplete - value[${e.target.value}]`);
    setCurrentValue(e.target.value);
    const { search } = props;
    search(currentValue);
  };

  return (
    <FormControl variant="outlined" style={customStyle}>
      <OutlinedInput
        type="text"
        style={{ height: 39 }}
        placeholder={label ? 'Search ' + label : ''}
        value={currentValue}
        onChange={handleChange}
        onBlur={handleChangeComplete}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        }
        endAdornment={
          <InputAdornment position="end">
            <IconButton disabled={!currentValue || currentValue.length == 0} onClick={clear} edge="end">
              <CloseIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  );
}
